import { render, staticRenderFns } from "./MobileDialog.vue?vue&type=template&id=253208dc&scoped=true&lang=pug"
import script from "./MobileDialog.vue?vue&type=script&lang=js"
export * from "./MobileDialog.vue?vue&type=script&lang=js"
import style0 from "./MobileDialog.vue?vue&type=style&index=0&id=253208dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253208dc",
  null
  
)

export default component.exports